import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { NavigationExtras, Router } from '@angular/router';
import { TileService, WordOfTheWeek } from '../../../widgets/services/tile.service';
import { GridModule } from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-word-of-the-week',
  standalone:true,
  imports: [GridModule],
  templateUrl: './page-word-of-the-week.component.html',
  styleUrls: ['./page-word-of-the-week.component.scss']
})
export class PageWordOfTheWeekComponent {
  title!: string;
  smartBankColour: any = '#03abba';
  uploadDataForm: FormGroup;
  constructor(private router: Router, private service: TileService, private http: HttpClient, private formBuilder: FormBuilder) {
    this.title = "Word of the Week";
    
    this.uploadDataForm = this.formBuilder.group({
      tip: new FormControl(null),
      tipName: new FormControl(null),
    });
    this.getWordOfTheweek();
    }

  saveWordOfTheWeek() {
  }
  getWordOfTheweek() {
    this.service.getWordOfTheWeek().then((data) => {
      this.wordOfTheWeekList = data;
    })
  }
  wordOfTheWeekList: WordOfTheWeek[] = [];
  deleteWordOfTheWeek(id: string) {
    if (confirm("Are you sure you want to delete this item?")) {
      this.service.deleteWordOfTheWeek(id).then((data) => {
        this.getWordOfTheweek();
      });
    }
  }
  gotoCreateWordOfTheWeek() {
    const navigationExtras: NavigationExtras = {
      state: {
        isEdit: true,
        editId: "",
        startDate: "",
        word: "",
        details: "",
      }
    };
    this.router.navigate(["createwordoftheweek/curation"], navigationExtras)
  }
  gotoEditWordOfTheWeek(ev: any) {
    const navigationExtras: NavigationExtras = {
      state: {
        isEdit: true,
        editId: ev.id,
        startDate: ev.startDate,
        word: ev.word,
        details: ev.details,

      }
    };
    this.router.navigate(["createwordoftheweek/curation"], navigationExtras)
  }
  HTMLdecode(str: any) {
    let txt = new DOMParser().parseFromString(str, "text/html");
    return txt.documentElement.textContent;
  }
}


